export function buildAuthRecoveryHref(returnTo: string): string {
  const signInHref = `/sign-in?returnTo=${encodeURIComponent(returnTo)}`;
  return `/sign-out?redirectTo=${encodeURIComponent(signInHref)}`;
}

export function signInAgain(): void {
  window.location.assign(
    buildAuthRecoveryHref(`${window.location.pathname}${window.location.search}`),
  );
}
